export default "<app-payment-list-view></app-payment-list-view>\r\n";